<template>
    <div>
        <v-cari-picker :code="$safe(cari,'CariKod') || null" v-on:pick="onCariPick" ref="picker"></v-cari-picker>
        <v-mu-picker ref="muPicker" :code="$safe(muhasebe,'MuhasebeKodu')" v-on:pick="onPickMuhasebe"/>

        <b-modal size="lg" id="kalem" title="Gider Kalemleri" no-close-on-esc no-close-on-backdrop>
            <fatura-kalem 
                v-model="kalem" 
                :doviz="model.CurrencyType != null && model.CurrencyType != 0" 
                :currency-rate="model.CurrencyRate"
            ></fatura-kalem>
            <template #modal-footer><v-executer :action="add">Ekle</v-executer></template>
        </b-modal>

        <div class="row">
            <div class="col-lg-3">
                <b-card no-body class="p-1">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <b-form-checkbox v-model="remember">Seçimleri Hatırla <br/><small>(Kasa, Gelir/Gider, C/H Efektif Tarihi, Proje Kodu)</small></b-form-checkbox>
                        </div>
                        <div class="col-12 mb-1">
                            <b-form-radio :value="0" inline v-model="type">Tek</b-form-radio>
                            <b-form-radio :value="1" inline v-model="type">Çok</b-form-radio>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Kasa</label>
                            <v-validator :errors="errors" parameter="VaultCode" :watch="kasa">
                                <v-select-list   v-model="kasa" v-on:input="getKasaDovizDeger" :options="kasaList" label="KSMAS_NAME" placeholder="Kasa" :loading="kasaLoading"></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Gelir/Gider</label>
                            <v-validator :errors="errors" parameter="VaultActionType" :watch="gcType">
                                <v-select-list v-model="gcType" label="Name" :options="gcTypes" placeholder="Gelir/Gider" ></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12">
                            <div class="mb-1" v-if="pleaseWait">
                                <span class="text-success">Döviz bilgileri getiriliyor. Lütfen Bekleyiniz... </span>
                            </div>
                            <v-validator :errors="errors" parameter="CurrencyRate" :watch="model.CurrencyRate">
                                <div class="table-responsive mb-1" v-if="currencyRateObj != null &&!pleaseWait && currencyRateObj.CurrencyType && model.CurrencyType != null">
                                    <table class="table table-sm table-bordered mb-0" width="100%">
                                        <tbody>
                                            <tr>
                                                <th>Döviz Alış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.DovizAlis" v-model="model.CurrencyRate" v-on:input="calculateAmounts" inline>
                                                        {{ currencyRateObj.DovizAlisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Döviz Satış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.DovizSatis" v-model="model.CurrencyRate" v-on:input="calculateAmounts" inline>
                                                        {{ currencyRateObj.DovizSatisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Döviz Ef. Alış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.EffAlis" v-model="model.CurrencyRate" v-on:input="calculateAmounts" inline>
                                                        {{ currencyRateObj.EffAlisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Döviz Ef. Satış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.EffSatis" v-model="model.CurrencyRate" v-on:input="calculateAmounts" inline>
                                                        {{ currencyRateObj.EffSatisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1" v-if="type == 0">
                            <label class="form-label">KDV Hesap Kodu</label>
                            <v-validator :errors="errors" parameter="KDVMuhasebeKarsilikKodu" :watch="KDVHesCode">
                                <v-select-list v-model="KDVHesCode" :options="KDVHesCodeList" label="Information" placeholder="KDV Hesap Kodu" :loading="KDVHesCodeLoading"></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">KDV Oranı (%)</label>
                            <input class="form-control" :disabled="type == 1" v-on:input="calculateAmounts" v-model="model.KDVRate" type="number" />
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">KDV'li Tutar (TL)</label>
                            <v-currency-input :disabled="(model.CurrencyType != null && model.CurrencyType != 0) || type == 1" input-class="text-right" :value="model.KDVDahilTutar" v-on:update-value="currencyAmount => {model.KDVDahilTutar = currencyAmount;calculateAmounts()}"></v-currency-input>
                        </div>
                        <div class="col-12 mb-1" v-if="model.CurrencyType != null && model.CurrencyType != 0">
                            <label class="form-label">KDV'li Döviz Tutar</label>
                            <v-currency-input input-class="text-right" :disabled="type == 1" :value="model.KDVliDovizTutar" v-on:update-value="currencyAmount => {model.KDVliDovizTutar = currencyAmount;calculateAmounts()}"></v-currency-input>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">KDV Öncesi Toplam Tutar (TL)</label>
                            <v-currency-input disabled input-class="text-right" :value="model.KDVOncesiTutar" v-on:update-value="currencyAmount => model.KDVOncesiTutar = currencyAmount"></v-currency-input>
                        </div>
                        <div class="col-12 mb-1" v-if="model.CurrencyType != null && model.CurrencyType != 0">
                            <label class="form-label">KDV'siz Döviz Tutar</label>
                            <v-currency-input disabled input-class="text-right" :value="model.KDVsizDovizTutar" v-on:update-value="currencyAmount => model.KDVsizDovizTutar = currencyAmount"></v-currency-input>
                        </div>
                        <div :class="['col-12',{'mb-1':(model.CurrencyType != null && model.CurrencyType != 0)}]">
                            <label class="form-label">KDV Tutar (TL)</label>
                            <v-currency-input disabled input-class="text-right" :value="model.KDVTutar" v-on:update-value="currencyAmount => model.KDVTutar = currencyAmount"></v-currency-input>
                        </div>
                        <div class="col-12" v-if="model.CurrencyType != null && model.CurrencyType != 0">
                            <label class="form-label">KDV Döviz Tutar</label>
                            <v-currency-input disabled input-class="text-right" :value="model.KDVDovizTutar" v-on:update-value="currencyAmount => model.KDVDovizTutar = currencyAmount"></v-currency-input>
                        </div>
                    </div>
                </b-card>
            </div>
            <div class="col-lg-3">
                <b-card no-body class="p-1">
                    <div class="row">
                        <div class="col-12 mb-1" v-if="type == 0">
                            <label class="form-label">Muhasebe Karşılık Kodu</label>
                            <div class="d-flex g-50">
                                <v-validator :errors="errors" parameter="MuhasebeKarsilikKodu" :watch="muhasebe">
                                    <input class="form-control" :value="$safe(muhasebe,'MuhasebeKodu')" readonly disabled placeholder="Muhasebe Kodu"/>
                                </v-validator>
                                <button class="btn btn-outline-primary text-nowrap" v-on:click="$refs.muPicker.pick()">Hesap Seç</button>
                            </div>
                            <small>{{ $safe(muhasebe,'MuhasebeAdi') }}</small>
                        </div>
                        <div class="col-12 mb-1" v-if="type == 0">
                            <label class="form-label">Miktar</label>
                            <input type="number" v-model="model.Miktar" class="form-control" placeholder="Miktar"/>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Cari</label>
                            <div class="d-flex g-50">
                                <v-validator :errors="errors" parameter="CariCode" :watch="cari">
                                    <input class="form-control" :value="$safe(cari,'CariKod')" readonly disabled placeholder="Cari"/>
                                </v-validator>
                                <button class="btn btn-outline-primary text-nowrap" v-on:click="$refs.picker.pick()">Cari Seç</button>
                            </div>
                            <small>{{ $safe(cari,'CariIsim') }}</small>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Kasa Rapor Açıklama</label>
                            <v-validator :errors="errors" parameter="KasaRapor_Kodu" :watch="reportCode">
                                <v-select-list v-model="reportCode" :options="reportCodes" label="Code" placeholder="Kasa Rapor Açıklama" ></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Proje Kodu</label>
                            <v-validator :errors="errors" parameter="ProjectCode" :watch="projectCode">
                                <v-select-list v-model="projectCode" :options="projectCodes" label="label" placeholder="Proje Kodu" ></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Belge Türü</label>
                            <v-validator :errors="errors" parameter="BelgeTuru" :watch="model.BelgeTuru">
                                <v-select-list :options="belgeTurus" label="Name" placeholder="Belge Türü" v-model="belgeTuru"></v-select-list>
                            </v-validator>
                        </div>
                        <!-- <div class="col-12 mb-1">
                            <label class="form-label">Plasiyer</label>
                            <v-validator :errors="errors" parameter="PlasiyerCode" :watch="plasiyerCode">
                                <v-select-list v-model="plasiyerCode" :loading="plasiyerLoading"  label="PlasiyerInformation" :options="plasiyerList" placeholder="Plasiyer"></v-select-list>
                            </v-validator>
                        </div> -->
                        <div class="col-12 mb-1">
                            <label class="form-label">C/H Efektif Tarihi</label>
                            <v-validator :errors="errors" parameter="EffectiveDate" :watch="model.EffectiveDate">
                                <v-date-picker v-model="model.EffectiveDate" placeholder="C/H Efektif Tarihi"/>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Açıklama</label>
                            <v-validator :errors="errors" parameter="VaultDescription" :watch="model.VaultDescription">
                                <textarea class="form-control resize-none" rows="2" placeholder="Açıklama" v-model="model.VaultDescription"></textarea>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">TMS Kasa Açıklama</label>
                            <v-validator :errors="errors" parameter="TMSVaultDescription" :watch="model.TMSVaultDescription">
                                <textarea class="form-control resize-none" rows="2" placeholder="TMS Kasa Açıklama" v-model="model.TMSVaultDescription"></textarea>
                            </v-validator>
                        </div>
                        <div class="col-12 text-right">
                            <v-executer :loading="saving" :action="save">Kaydet</v-executer>
                        </div>
                    </div>
                </b-card>
            </div>
            <div class="col-lg-6" v-if="type == 1">
                <b-card no-body class="p-0">
                    <div class="p-75">
                        <button class="btn btn-primary" v-on:click="openAdd" :disabled="((this.model.CurrencyType != null && this.model.CurrencyType != 0) && !model.CurrencyRate) || !kasa">
                            Karşı Hesap Ekle
                        </button>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-sm bordered-header">
                            <thead>
                                <th>İşlemler</th>
                                <th>Hesap Kodu</th>
                                <th>Hesap Adı</th>
                                <th>Tutar (TL)</th>
                                <th>Döviz Tutar</th>
                                <th>Miktar</th>
                                <th>Açıklama</th>
                                <th>KDV Oranı</th>
                            </thead>
                            <tbody>
                                <tr v-for="(k,i) in model.KDVKalems" :key="i">
                                    <td>
                                        <button class="btn btn-flat-danger btn-sm btn-icon" v-on:click="$delete(model.KDVKalems,i)">
                                            <feather-icon icon="TrashIcon"/>
                                        </button>
                                    </td>
                                    <td>{{ $safe(k,'Kod') || "-" }}</td>
                                    <td>{{ $safe(k,'Ad') || "-" }}</td>
                                    <td>{{ convertMoney($safe(k,'Tutar') || "0") }}</td>
                                    <td>{{ convertMoney($safe(k,'DOVTUT') || "0") }}</td>
                                    <td>{{ $safe(k,'Miktar') || "-" }}</td>
                                    <td>{{ $safe(k,'Aciklama') || "-" }}</td>
                                    <td>{{ $safe(k,'Kdv_Oran') || "-" }}</td>
                                </tr>
                                <tr v-if="(model.KDVKalems || []).length == 0">
                                    <td colspan="1000" class="text-center">Henüz bir kalem eklememiştir.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-card>
            </div>
            <div class="col-12">
                <b-card no-body>
                    <v-table    ref="table"
                                name="vault-actions"
                                with-items
                                :settings="false"
                                :fields="fields"
                                search
                                :buttons="buttons"
                                :items="kasaHareketToday">
                            <template #additional-actions>
                                <h4 class="mb-0">Bugünkü Hareketler</h4>
                            </template>
                            </v-table>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import { BCard, BFormRadio, BFormCheckbox } from 'bootstrap-vue'
import NetsisOperationsApi from '@/api/netsis-operations'
import VValidator from '@/components/VValidator.vue'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import FaturaKalem from './components/FaturaKalem.vue'
import Additional from '@/utilities/additional'
import VCariPicker from '@/components/VCariPicker.vue'
import VMuPicker from '@/components/VMuPicker.vue';
import { printFaturaFis } from '../components/fis/print-fatura-fis'
import moment from 'moment'
import { printFis } from '../../vault-actions/components/fis/print-fis.js'
export default {
    components:{
        BCard,
        BFormRadio,
        VValidator,
        VCurrencyInput,
        FaturaKalem,
        VCariPicker,
        VMuPicker,
        BFormCheckbox
    },
    data(){
        return {
            remember:false,
            errors:{},
            pleaseWait: false,
            kasaLoading:false,
            kasaList:[],
            raporCodes:[],
            projectCodes:[
                {value:'R',label:'Banka 1'},
                {value:'G',label:'Banka 2'},
            ],
            plasiyerLoading:false,
            plasiyerList:[],
            cari:null,
            muhasebe:null,
            KDVHesCodeLoading:false,
            KDVHesCodeList:[ 
                {Information:"191-01-01-0001 - % 1 KDV",MuhasebeAdi:"% 1 KDV",MuhasebeKodu:"191-01-01-0001",Value:1},
                {Information:"191-01-01-0010 - % 10 KDV",MuhasebeAdi:"% 10 KDV",MuhasebeKodu:"191-01-01-0010",Value:10},
                {Information:"191-01-01-0020 - % 20 KDV",MuhasebeAdi:"% 20 KDV",MuhasebeKodu:"191-01-01-0020",Value:20},
            ],
            type:0,
            gcTypes:[{Name:'Gelir',Value:'G'},{Name:'Gider',Value:'C'}],
            belgeTurus:[],
            model:{
                VaultCode:null,
                VaultName:null,
                EffectiveDate:moment().format('YYYY-MM-DD'),
                VaultActionType:null,
                CurrencyType:null,
                IsCurrency:null,
                CurrencyRate:null,
                KDVDahilTutar: 0,
                KDVliDovizTutar: 0,
                KDVsizDovizTutar:0,
                KDVRate: 0,
                KDVOncesiTutar:0,
                KDVTutar:0,
                KDVDovizTutar:0,
                FaturaNo:null,
                ProjectCode:null,
                KasaRaporKodu:null,
                PlasiyerCode:null,
                PlasiyerName:null,
                Miktar:null,
                MuhasebeKarsilikKodu: null,
                MuhasebeKarsilikAdi: null,
                KDVMuhasebeKarsilikKodu: null,
                KDVMuhasebeKarsilikAdi: null,
                VaultDescription:null,
                TMSVaultDescription:null,
                KDVKalems:[]
            },
            currencyRateObj:{
                CurrencyType:null,
                Date:null,
                DovizAlis:null,
                DovizSatis:null,
                EffAlis:null,
                EffSatis:null,
                DovizAliStr:null,
                DovizSatisStr:null,
                EffAlisStr:null,
                EffSatisStr:null,
            },
            kalem:{
                Kod: null,
                Ad: null,
                Tutar: null,
                Kdv_Oran: null,
                KdvMuhKod: null,
                Kdv_Dahil: false,
                Aciklama: null,
                DOVTUT: null,
                Miktar: null,
                KdvTutar: null,
                KdvDovTut: null
            },
            saving:false,
            reportCodes:[],
            fields:[
                { name:'Kasa Kodu',key:'KSMAS_KOD', tdClass:'text-nowrap',thClass:'w-6'},
                { name:'Kasa Adı',key:'KSMAS_NAME',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tarih',key:'TARIHStr',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Zaman',key:'ZAMAN',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'G/Ç',key:'IO',thClass:'w-7', tdClass:'text-nowrap'},
                { name:'Fiş No',key:'FIS_NO',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tip',key:'TIP',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Açıklama',key:'ACIKLAMA',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'TMS Açıklama',key:'TMSVaultDescription',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tutar',key:'TUTARStr', tdClass:'text-nowrap text-right',thClass:'w-7', tdClass:'text-nowrap text-right'},
                { name:'Cari/Muh',key:'CARI_MUH', tdClass:'text-nowrap',thClass:'w-7'},
                { name:'Kod',key:'KOD',thClass:'w-7', tdClass:'text-nowrap', tdClass:'text-nowrap'},
                { name:'Cari Adı',key:'CARI_ISIM',thClass:'w-7', tdClass:'text-nowrap '},
                { name:'Muh. Adı', key:'MUH_ADI', tdClass:'text-nowrap',thClass:'w-7'},
                { name:'Plasiyer Adı',key:'PLASIYER_ISIM',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Şube Adı',key:'SUBE_ADI', tdClass:'text-nowrap',thClass:'w-16'},
            ],
            buttons:[
                { text:"Tediye Fişi Yazdır",key:"ted-fis",icon:"PrinterIcon",variant:"primary",action:this.printTediye },
                { text:"Yevmiye Fişi Yazdır",key:"ted-fis",icon:"PrinterIcon",variant:"secondary",action:this.print },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.deleteHareket },
            ],
            kasaHareketToday:[],
        }
    },
    watch:{
        type(ow,nw){
            if(ow != nw) this.clearForm(true)
        }
    },
    mounted(){
        this.getKasaList()
        this.getReportCodes()
        this.getPlasiyerList()
        this.getBelgeTurus()
        this.getKasaHareketToday()
    },
    methods:{
        getReportCodes(){
            NetsisOperationsApi.ReportCode.List().then(res => {
                if(res.data.Success){
                    this.reportCodes = res.data.Data || []
                }
            })
        },
        clearKasaChange(){
            this.model.CurrencyRate = null
            this.model.KDVDahilTutar = 0
            this.model.KDVliDovizTutar = 0
            this.model.KDVsizDovizTutar = 0
            this.model.KDVRate = 0
            this.model.KDVOncesiTutar = 0
            this.model.KDVTutar = 0
            this.model.KDVDovizTutar = 0
            this.currencyRateObj = {
                CurrencyType:null,
                Date:null,
                DovizAlis:null,
                DovizSatis:null,
                EffAlis:null,
                EffSatis:null,
                DovizAliStr:null,
                DovizSatisStr:null,
                EffAlisStr:null,
                EffSatisStr:null,
            }
        },
        clearForm(bool){
            if(!this.remember){
                this.model.ProjectCode = null
                this.model.VaultCode = null
                this.model.VaultName = null
                this.model.EffectiveDate = moment().format('YYYY-MM-DD')
            }
            this.model.CariIsim = null
            this.model.CariKod = null
            this.model.CurrencyType = null
            this.model.VaultActionType = null
            this.model.IsCurrency = null
            this.model.CurrencyRate = null
            this.model.KDVDahilTutar = 0
            this.model.KDVliDovizTutar = 0
            this.model.KDVsizDovizTutar = 0
            this.model.KDVRate = 0
            this.model.KDVOncesiTutar = 0
            this.model.KDVTutar = 0
            this.model.KDVDovizTutar = 0
            this.model.FaturaNo = null
            this.model.KasaRaporKodu = null
            this.model.PlasiyerCode = null
            this.model.PlasiyerName = null
            this.model.Miktar = null
            this.model.MuhasebeKarsilikKodu = null
            this.model.MuhasebeKarsilikAdi = null
            this.model.KDVMuhasebeKarsilikKodu = null
            this.model.KDVMuhasebeKarsilikAdi = null
            this.model.VaultDescription = null
            this.model.TMSVaultDescription = null
            this.model.KDVKalems = []
            this.model.BelgeTuru = null
            this.muhasebe = null
            this.cari = null
            if(!bool) this.type = 0
            this.clearKasaChange()
        },
        getKasaHareketToday(){
            this.$refs.table.setLoading(true)
            NetsisOperationsApi.GetFaturaKasaHareketToday().then((res)=>{
                this.kasaHareketToday = res.data.Data
                this.$refs.table.setLoading(false)
            }).catch(err=> {
                this.$refs.table.setLoading(false)
                console.log(err)
            })
        },
        getKasaDovizDeger(){
            if(this.model.CurrencyType != null){
                this.clearKasaChange()
                this.pleaseWait=true
                this.model.CurrencyRate = null
                this.model.CurrencyType = this.model.CurrencyType == null ? 0 : this.model.CurrencyType
                NetsisOperationsApi.GetNetsisCurrencyData(this.model.CurrencyType).then((res) => {
                    if(res.data.Data != null){
                        this.currencyRateObj = res.data.Data
                    }else{
                        this.currencyRateObj = null
                    }
                    this.pleaseWait=false
                }).catch(err=> {
                    console.log(err)
                })
            }
        },
        getKasaList(){
            this.kasaLoading = true
            NetsisOperationsApi.GetKasaList().then(res => {
                    this.kasaList = res.data.Data
                    this.kasaLoading = false
            }).catch(err=> {
                console.log(err)
                this.kasaLoading = false
            })
        },
        calculateAmounts(){
            const currentrate = Number(this.model.CurrencyRate || 0) || 0
            const kdvlitutar = Number(this.model.KDVDahilTutar || 0) || 0
            const kdvrate = Number(this.model.KDVRate || 0) || 0
            const kdvlidoviztutar = Number(this.model.KDVliDovizTutar || 0) || 0

            if(this.model.CurrencyType != null && this.model.CurrencyType != 0){
                this.model.KDVsizDovizTutar =  (kdvlidoviztutar / (1 + (kdvrate / 100)))
                this.model.KDVDovizTutar = kdvlidoviztutar - this.model.KDVsizDovizTutar
                this.model.KDVDahilTutar = kdvlidoviztutar * currentrate
                this.model.KDVOncesiTutar = (this.model.KDVsizDovizTutar) * currentrate
                this.model.KDVTutar = (this.model.KDVDovizTutar) * currentrate

            }else{
                this.model.KDVOncesiTutar = (kdvlitutar / (1 + (kdvrate / 100)))
                this.model.KDVTutar =  kdvlitutar - this.model.KDVOncesiTutar
            }
        },
        getBelgeTurus(){
            NetsisOperationsApi.BelgeTuru.List().then(res => {
                this.belgeTurus = res.data.Data || []
            })
        },
        getPlasiyerList(){
            this.plasiyerLoading = true
            NetsisOperationsApi.GetPlasiyerList().then((res) => {
                this.plasiyerList = res.data.Data
                this.plasiyerLoading = false
            }).catch(err=> {
                console.log(err)
                this.plasiyerLoading = false
            })
        },
        getKDVHesCodeList(){
            this.KDVHesCodeLoading = true
            NetsisOperationsApi.GetKDVCodes().then(res => {
                this.KDVHesCodeList = res.data.Data || []
                this.KDVHesCodeLoading = false
            }).catch(() => {
                this.KDVHesCodeLoading = false
            })
        },
        clearKalem(){
            this.kalem.Kod = null
            this.kalem.Ad = null
            this.kalem.Tutar = null
            this.kalem.Kdv_Oran = null
            this.kalem.KdvMuhKod = null
            this.kalem.KdvMuhAdi = null
            this.kalem.Kdv_Dahil = false
            this.kalem.Aciklama = null
            this.kalem.DOVTUT = null
            this.kalem.Miktar = null
            this.kalem.KdvTutar = null
            this.kalem.KdvDovTut = null
        },
        openAdd(){
            this.clearKalem()
            this.$showModal('kalem')
        },
        add(){
            this.model.KDVKalems.push(structuredClone(this.kalem))
            this.clearKalem()
        },
        convertMoney(k){
            return Additional.ConvertMoney(k)
        },
        save(){
            this.saving = true
            NetsisOperationsApi.SaveFaturaKasaHareket(this.model).then(res => {
                if(res.data.Success){
                    this.clearForm()
                    this.print({FIS_NO:res.data.Data})
                }
                this.saving = false
                this.$result(res)
            }).catch(err => {
                this.saving = false
                this.$result(null,err)
            })
        },
        onCariPick(e){
            this.model.CariKod = e?.CariKod || null
            this.model.CariAdi = e?.CariIsim || null
            this.cari = e
        },
        onPickMuhasebe(e){
            this.model.MuhasebeKarsilikKodu = e?.MuhasebeKodu || null
            this.model.MuhasebeKarsilikAdi = e?.MuhasebeAdi || null
            this.model.VaultDescription = e?.MuhasebeAdi || null
            this.muhasebe = e
        },
        print(i){
            if(i.FIS_NO){
                this.$refs?.table?.rowLoading(true)
                NetsisOperationsApi.TediyeFis(i.FIS_NO,'F',i.SIRA).then(res => {
                    this.$refs?.table?.rowLoading(false)
                    if(res.data.Success){
                        printFaturaFis(res.data.Data)
                    }else{
                        this.$result(res)
                    }
                }).catch(err => {
                    this.$refs?.table?.rowLoading(false)
                    this.$result(null,err)
                })
            }
        },
        printTediye(i){
            if(i.FIS_NO && i.TIP && i.SIRA){
                this.$refs.table.rowLoading(true)
                NetsisOperationsApi.FaturaFisTediye(i.FIS_NO,i.SIRA).then(res => {
                    this.$refs.table.rowLoading(false)
                    if(res.data.Success){
                        printFis(res.data.Data)
                    }else{
                        this.$result(res)
                    }
                }).catch(err => {
                    this.$refs.table.rowLoading(false)
                    this.$result(null,err)
                })
            }
        },
    },
    computed:{
        kasa:{
            get:function(){
                return this.kasaList.find(s=>s.KSMAS_KOD==this.model.VaultCode)
            },
            set:function(value){
                this.model.VaultCode = value?.KSMAS_KOD || null
                this.model.VaultName = value?.KSMAS_NAME || null
                this.model.CurrencyType = value?.DOVIZTIPI || null
                this.model.IsCurrency = value?.DOVIZLI || null
            }
        },
        plasiyerCode:{
            get:function(){
                return this.plasiyerList.find(s=>s.PlasiyerCode==this.model.PlasiyerCode)
            },
            set:function(value){
                this.model.PlasiyerCode = value?.PlasiyerCode || null
                this.model.PlasiyerName = value?.PlasiyerName || null
            }
        },
        KDVHesCode:{
            get:function(){
                return this.KDVHesCodeList.find(s=>s.MuhasebeKodu==this.model.KDVMuhasebeKarsilikKodu)
            },
            set:function(value){
                this.model.KDVMuhasebeKarsilikKodu = value?.MuhasebeKodu || null
                this.model.KDVMuhasebeKarsilikAdi = value?.MuhasebeAdi || null
                if(value?.Value){
                    this.model.KDVRate = value?.Value
                    this.calculateAmounts()
                }
            }
        },
        gcType:{
            get:function(){
                return this.gcTypes.find(s=>s.Value==this.model.VaultActionType)
            },
            set:function(value){
                this.model.VaultActionType = value?.Value || null
            }
        },
        reportCode:{
            get:function(){
                return this.reportCodes.find(s=>s.Code==this.model.KasaRaporKodu)
            },
            set:function(value){
                this.model.KasaRaporKodu = value?.Code || null
            }
        },
        projectCode:{
            get:function(){
                return this.projectCodes.find(s=>s.value==this.model.ProjectCode)
            },
            set:function(value){
                this.model.ProjectCode = value?.value || null
            }
        },
        belgeTuru:{
            get:function(){
                return this.belgeTurus.find(s=>s.Name==this.model.BelgeTuru)
            },
            set:function(value){
                this.model.BelgeTuru = value?.Name || null
            }
        }
    }
}
</script>